"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeedmapsCategory = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class WeedmapsCategory {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], WeedmapsCategory.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], WeedmapsCategory.prototype, "name", void 0);
exports.WeedmapsCategory = WeedmapsCategory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2VlZG1hcHNDYXRlZ29yeS5qcyIsInNvdXJjZVJvb3QiOiIuL3NyYy8iLCJzb3VyY2VzIjpbInBhY2thZ2VzL21vZGVscy9zcmMvd2VlZG1hcHNDYXRlZ29yeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEscUNBQWlDO0FBRWpDLE1BQWEsZ0JBQWdCO0NBTTVCO0FBSkc7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLENBQUM7OzRDQUNoQjtBQUNYO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDOzs4Q0FDZDtBQUxqQiw0Q0FNQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbHVtbiB9IGZyb20gXCJ0eXBlb3JtXCI7XG5cbmV4cG9ydCBjbGFzcyBXZWVkbWFwc0NhdGVnb3J5IHtcblxuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIGlkOiBzdHJpbmc7XG4gICAgQENvbHVtbih7IG51bGxhYmxlOiB0cnVlIH0pXG4gICAgbmFtZTogc3RyaW5nO1xufSJdfQ==